import script from "./baseInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./baseInfo.vue?vue&type=script&setup=true&lang=js"

import "./baseInfo.vue?vue&type=style&index=0&id=0ff9974c&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ff9974c"]])

export default __exports__